module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mymessage"
  }, [_c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "testclass"
  }, [_c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "overview-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(this.$store.state.uuid != null) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.myinfo.avatar,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.state.avatarvip,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "overview-right"
  }, [(this.$store.state.uuid != null) ? _c('div', {
    staticClass: "score-wrapper"
  }, [_c('div', {
    staticClass: "title-father",
    on: {
      "click": function($event) {
        _vm.modifymyinfo()
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$store.state.myinfo.description))])]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.$store.state.myinfo.username))])]) : _c('div', {
    staticClass: "score-wrapper"
  }, [_c('div', {
    staticClass: "title-father"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('notsignin')))])])])])]), _vm._v(" "), _c('split'), _vm._v(" "), (this.$store.state.uuid != null) ? _c('div', {
    staticClass: "rating-type"
  }, [_c('div', {
    staticClass: "img-wrapper",
    on: {
      "click": function($event) {
        _vm.selectFood('待收货')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('./serving.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pending')))])]), _vm._v(" "), _c('div', {
    staticClass: "img-wrapper",
    on: {
      "click": function($event) {
        _vm.selectFood('完成')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('./finished.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('complete')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "listContent",
    staticClass: "list-content"
  }, [_c('ul', [(this.$store.state.uuid != null) ? _c('li', {
    staticClass: "mymessagefood",
    on: {
      "click": function($event) {
        _vm.selectFood('我的地址')
      }
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('myaddress')))]), _vm._v(" "), _c('div', {
    staticClass: "cartcontrol-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "https://api.freepos.es/files/sample/default_header.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "mymessagefood",
    on: {
      "click": function($event) {
        _vm.selectFood('客服电话')
      }
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('customerservice')))]), _vm._v(" "), _c('div', {
    staticClass: "cartcontrol-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "https://api.freepos.es/files/sample/default_header.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mymessagefood",
    on: {
      "click": function($event) {
        _vm.selectFood('在线客服')
      }
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('onlineservice')))]), _vm._v(" "), _c('div', {
    staticClass: "cartcontrol-wrapper"
  }, [_c('img', {
    attrs: {
      "src": "https://api.freepos.es/files/sample/default_header.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "mymessagefood"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('language')))]), _vm._v(" "), _c('div', {
    staticClass: "locale-changer"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Language"
    },
    model: {
      value: (_vm.$i18n.locale),
      callback: function($$v) {
        _vm.$set(_vm.$i18n, "locale", $$v)
      },
      expression: "$i18n.locale"
    }
  }, _vm._l((_vm.langs), function(lang, i) {
    return _c('el-option', {
      key: ("Lang" + i),
      attrs: {
        "value": lang,
        "label": _vm.langsname[i]
      }
    })
  }))], 1)]), _vm._v(" "), _c('li', {
    staticClass: "mymessagefood2",
    on: {
      "click": function($event) {
        _vm.singinAndsingout()
      }
    }
  }, [(this.$store.state.uuid != null) ? _c('div', {
    staticClass: "cartcontrol-wrapper2"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('signout')) + "\n                      ")]) : _c('div', {
    staticClass: "cartcontrol-wrapper-login"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('signin')) + "\n                      ")])])])])], 1)]), _vm._v(" "), _c('returnbutton', {
    ref: "returnbutton"
  }), _vm._v(" "), _c('myaddress', {
    ref: "myaddress"
  }), _vm._v(" "), _c('orders', {
    ref: "orders"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-612d155d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mymessage/mymessage.vue
// module id = 469
// module chunks = 1